import React__default, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';
import '../../buttons/index.js';
import ProcessingZoneContainer from '../components/ProcessingZone/ProcessingZoneContainer.js';
import UploadDropzoneComponent from './UploadDropzoneComponent.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const UploadDropzoneContainer = ({ type = 'condensed', fileBrowseTitle, dragDropTitle, activeClassName, classes, disabled, acceptedFileTypes, maxFileSizeBytes, maxFiles, multiple, files, processingConfig, uploadFile, onFilesRejected, customValidator }) => {
    const areFilesUnprocessed = !!files.find((file) => !file.processed && !file.error);
    const showProcessingFlow = processingConfig && (processingConfig?.status === 'pending' || areFilesUnprocessed);
    const basicConfig = {
        noClick: true,
        noKeyboard: true,
        accept: acceptedFileTypes,
        maxSize: maxFileSizeBytes,
        maxFiles,
        validator: customValidator,
        multiple
    };
    const config = type === 'simple'
        ? {
            ...basicConfig,
            noDrag: true,
            maxFiles: 1,
            multiple: false
        }
        : basicConfig;
    const { getRootProps, getInputProps, open, acceptedFiles, fileRejections, isDragActive } = useDropzone(config);
    const initialDropzoneClassName = clsx('c-dropzone', type === 'condensed' && 'c-dropzone--condensed');
    const [dropzoneClass, setDropzoneClass] = useState(initialDropzoneClassName);
    useEffect(() => {
        if (isDragActive) {
            setDropzoneClass(clsx(dropzoneClass, activeClassName || 'c-dropzone--highlight'));
        }
        else {
            setDropzoneClass(initialDropzoneClassName);
        }
    }, [activeClassName, dropzoneClass, initialDropzoneClassName, isDragActive]);
    useEffect(() => {
        if (acceptedFiles.length) {
            acceptedFiles.forEach((file) => uploadFile(file));
        }
        if (fileRejections.length && onFilesRejected) {
            onFilesRejected(fileRejections);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles.length, fileRejections.length]);
    return (React__default.createElement("div", null,
        React__default.createElement(Visible, { when: showProcessingFlow },
            React__default.createElement(ProcessingZoneContainer, { ...{ ...processingConfig, files } })),
        React__default.createElement(Visible, { when: !showProcessingFlow },
            React__default.createElement(UploadDropzoneComponent, { type: type, dropzoneClass: dropzoneClass, fileBrowseTitle: fileBrowseTitle, dragDropTitle: dragDropTitle, classes: classes, getRootProps: getRootProps, getInputProps: getInputProps, open: open, disabled: disabled }))));
};

export { UploadDropzoneContainer as default };
//# sourceMappingURL=UploadDropzoneContainer.js.map
